import { render } from "./dashboardgestioncommandesligne.vue?vue&type=template&id=2df35c21"
import script from "./dashboardgestioncommandesligne.vue?vue&type=script&lang=js"
export * from "./dashboardgestioncommandesligne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__